import React from "react";

interface MessageViewProps {
  message: string;
}

export const MessageView = ({
  message = '',
}: MessageViewProps) => (
  <div className="text-center text-gray-600">
    {message}
  </div>
)